module.exports = __webpack_public_path__ + "static/media/demo_4.1606574a.mp4";